import { render, staticRenderFns } from "./Numeric.vue?vue&type=template&id=55096a04&scoped=true&"
import script from "./Numeric.vue?vue&type=script&lang=ts&"
export * from "./Numeric.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55096a04",
  null
  
)

export default component.exports